import React, { useState } from "react";
import Button from "../../components/button/button";
import { colors } from "../../utils/theme";
//@ts-ignore
import { ReactComponent as Referral } from "../../assets/svg/referral.svg";
import { useDispatch } from "react-redux";
import { logout } from "../../store/actions/auth.action";
import { resetSearchData } from "../../store/actions/search.action";
import axios from "axios";

const AddReferralAccount: React.FC = () => {
  const dispatch = useDispatch();
  const [openLogoutModel, setOpenLogoutModel] = useState<boolean>(false);

  // const handleLogout = () => {
  //   setOpenLogoutModel(!openLogoutModel);
  //   dispatch(logout());
  //   localStorage.removeItem("searchData");
  //   dispatch(resetSearchData());
  //   window.location.href = "/register-ambassador";
  // };

  const handleLogout = () => {
  setOpenLogoutModel(!openLogoutModel);
  
  // Get sessionId before clearing localStorage
  const sessionId = localStorage.getItem("sessionId");
  
  // Call logout API to revoke the session on server
  if (sessionId) {
    axios.post('/api/auth/logout', { sessionId })
      .catch(err => console.error("Logout API error:", err));
  }
  
  // Dispatch logout action (this should handle socket disconnection)
  dispatch(logout());
  
  // Clear local storage
  localStorage.removeItem("searchData");
  localStorage.removeItem("accessToken");
  localStorage.removeItem("refreshToken");
  localStorage.removeItem("sessionId"); // Clear sessionId
  
  dispatch(resetSearchData());
  window.location.href = "/register-ambassador";
};

  return (
    <div className="flex flex-col bg-white flex-1 h-full w-full shadow-[2px_2px_12px_0px_rgba(180,180,180,0.25)] rounded-lg p-6 overflow-y-scroll no-scrollbar pb-10">
      <div className="bg-[#F1F5F9] pt-[75px] pb-9 px-20 gap-6 flex flex-col">
        <span className="font-bold text-[40px] text-primary">
          Track Referrals. Earn Benefits.
          <br />
          Stay Connected
        </span>
        <span className="text-[15px] text-primary">
          Log in to track your referrals and unlock exclusive rewards.
          <br />
          Your network is your power — let’s make it count.
        </span>
        <div className="flex gap-3 items-center">
          <span className="text-[15px] text-primary">
            Click here to get started
          </span>
          <Button
            style={{ borderRadius: 4 }}
            color={colors.SecondaryOrange}
            onClick={() => setOpenLogoutModel(!openLogoutModel)}
          >
            Register Now
          </Button>
        </div>
      </div>
      <div className="mt-10 ml-16">
        <Referral />
      </div>

      {openLogoutModel && (
        <div className="fixed top-0 left-0 w-full h-full bg-black bg-opacity-50  flex justify-center items-center z-50">
          <div className="flex flex-col gap-6 bg-white p-6 rounded-lg px-5 py-8">
            <span className="text-xl font-semibold text-primary">
              Logout from candidate account?
            </span>
            <span className="text-sm text-center font-medium text-primary">
              To log in as a referral member, please log out of
              <br />
              your candidate account first.
            </span>
            <div className="flex gap-3 mt-8">
              <Button
                style={{ borderRadius: 4, flex: 1 }}
                variant="outline"
                color={colors.PrimaryBlack}
                onClick={() => setOpenLogoutModel(!openLogoutModel)}
              >
                Not now
              </Button>
              <Button
                style={{ borderRadius: 4, flex: 1 }}
                color={colors.PrimaryBlack}
                onClick={handleLogout}
              >
                Yes, logout
              </Button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AddReferralAccount;
